import {
  AttributeBase,
  GroupedPassedItem,
  Leg,
  LegAttribute
} from '@approot/models';
import { Utilities } from '@approot/utilities';

export function getAttributeControlFromKey(
  attributeName: string,
  filteredControls: AttributeBase<any>[]
): AttributeBase<any> {
  // takes in an attribute name and returns the attribute control from the array
  let attributeFromKey;
  filteredControls?.forEach(attribute => {
    if (attribute.key === attributeName) {
      attributeFromKey = attribute;
      return;
    }

    if (
      attribute.controlType === 'list' ||
      attribute.controlType === 'bidAskList'
    ) {
      const listAtt = getAttributeControlFromKey(
        attributeName,
        attribute.attributes
      ); // we use recursion to find attributes in inner lists
      if (listAtt) {
        attributeFromKey = listAtt;
        return;
      }
    }
  });
  return attributeFromKey;
}

export function getAllAttributes(
  attributes: AttributeBase<any>[]
): AttributeBase<any>[] {
  return attributes.flatMap(attribute => {
    if (
      attribute.controlType === 'list' ||
      attribute.controlType === 'bidAskList'
    ) {
      return getAllAttributes(attribute.attributes);
    }
    return attribute;
  });
}

export function getAllAttributeOptions(key: string, leg: Leg): any[] {
  let attributes = getAttributeControlFromKey(
    key,
    leg.attributesAsFormControls
  );

  if (attributes && attributes.options) {
    return getAllOptions(attributes.options);
  } else {
    return [];
  }
}

export function getAllOptions(options: string[] | GroupedPassedItem[]): any[] {
  if (!options) {
    return [];
  }

  return options.flatMap(x => {
    if (typeof x === 'string' || typeof x === 'boolean') {
      return x;
    }
    return x.items;
  });
}

export function getAttributeControlType(key: string, leg: Leg): string {
  let attribute = getAttributeControlFromKey(key, leg.attributesAsFormControls);
  if (attribute && attribute.controlType) {
    return attribute.controlType;
  } else return '';
}

export function getAttributeFromKey(
  leg: Leg,
  attributeName: string,
  filteredAttributes?: LegAttribute[]
): LegAttribute {
  // takes in an attribute name and returns the attribute control from the array
  let attributeFromKey;
  (filteredAttributes || leg.attributes).forEach(attribute => {
    if (attribute.type === 'list' || attribute.type === 'bidAskList') {
      const listAtt = getAttributeFromKey(
        leg,
        attributeName,
        attribute.attributes
      ); // we use recursion to find attributes in inner lists
      if (listAtt) {
        attributeFromKey = listAtt;
        return;
      }
    } else {
      if (attribute.shortName === attributeName) {
        attributeFromKey = attribute;
        return;
      }
    }
  });
  return attributeFromKey;
}

export function removeDateLag(attributeName: string, leg: Leg) {
  // remove the date lag from the attribute
  const attribute = getAttributeControlFromKey(
    attributeName,
    leg.attributesAsFormControls
  );
  if (attribute) {
    attribute.info = '';
  }
}
